import React, { useState, useEffect } from "react";
import { useHistory, Link, useLocation } from "react-router-dom";
import "../../assets/styles/local/Bookkeeping.css";
import Header from "../../layouts/Header";
import CompanyLogo from "../../assets/icons/CompanyLogo.png";
import { useDispatch, useSelector } from "react-redux";

const Bookkeeping = () => {
  const bookkeeping_props = useSelector(
    (state) => state.user.bookkeeping_props
  );

  const redrectValue = window.localStorage.getItem("redrectValue");

  useEffect(() => {
    if (redrectValue) {
      setTimeout(() => {
        // window.location.href = "https://accounts.intuit.com/app/sign-in?app_group=QBO&asset_alias=Intuit.accounting.core.qbowebapp&app_environment=prod"

        window.open(
          "https://accounts.intuit.com/app/sign-in?app_group=QBO&asset_alias=Intuit.accounting.core.qbowebapp&app_environment=prod"
        );

        localStorage.removeItem("redrectValue");
      }, 1000);
    }
  }, []);

  return (
    <>
      <Header />

      <div className="container-fluid pt-5">
        <div className="pt-3 d-flex justify-content-center align-self-center flex-wrap bookDiv">
          <img className="bookLogo" src={CompanyLogo} alt="" />
          <p className="bookText">
            We are <br /> redirecting to <br /> Quickbooks.
            <br />{" "}
            <p className="loadingText pt-2">Please wait while loading.</p>
          </p>
        </div>
      </div>
    </>
  );
};

export default Bookkeeping;
